import React from "react";
import Icon, { IconProps } from "./Icon";

const ChevronDownIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </Icon>
  );
};

export default ChevronDownIcon;
